import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
  CImage
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilBell, cilEnvelopeOpen, cilList, cilMenu } from '@coreui/icons'
import NotificationBellIcon from '../assets/icons/NotificationBellIcon.png'
import MagnifyingGlassIcon from '../assets/icons/MagnifyingGlassIcon.png'

// Component
import AppBreadcrumb from './AppBreadcrumb'
import AppHeaderDropdown from './header/AppHeaderDropdown'

// Icons
import { logo } from 'src/assets/brand/logo'
import CloudxierIcon from 'src/assets/icons/CloudxierLogoInWhite.png'

const AppHeader = ({
  homeDisplayName,
  aboutUsDisplayName,
  contactUsDisplayName,
  faqDisplayName,
  ourServicesDisplayName
}) => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)

  return (
    <CHeader position="sticky" className="mb-4">
      <CContainer fluid>
        <CHeaderToggler
          className="ps-1"
          onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <CHeaderBrand className="mx-auto d-md-none" to="/">
          <CImage fluid src={CloudxierIcon} />
        </CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto">
          {/* <CNavItem>
            <CNavLink href="#">
              <CImage fluid src={MagnifyingGlassIcon} className="me-3" />
              Search
            </CNavLink>
          </CNavItem> */}
        </CHeaderNav>
        <CHeaderNav>
          {/* <CNavItem>
            <CNavLink href="#">
              <CImage fluid src={NotificationBellIcon} />
            </CNavLink>
          </CNavItem> */}
        </CHeaderNav>
        <CHeaderNav className="ms-3">
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
      <CHeaderDivider />
      <CContainer fluid>
        <AppBreadcrumb
          homeDisplayName={homeDisplayName}
          aboutUsDisplayName={aboutUsDisplayName}
          contactUsDisplayName={contactUsDisplayName}
          faqDisplayName={faqDisplayName}
          ourServicesDisplayName={ourServicesDisplayName}
        />
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
